/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createTourOperatorAllotmentVerificationFromDiscriminatorValue, type TourOperatorAllotmentVerification } from '../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/VerifyBusinessRule/CreateFromCsv
 */
export interface CreateFromCsvRequestBuilder extends BaseRequestBuilder<CreateFromCsvRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TourOperatorAllotmentVerification[]>}
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TourOperatorAllotmentVerification[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CreateFromCsvRequestBuilderUriTemplate = "{+baseurl}/Allotment/VerifyBusinessRule/CreateFromCsv";
/**
 * Metadata for all the requests in the request builder.
 */
export const CreateFromCsvRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CreateFromCsvRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createTourOperatorAllotmentVerificationFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
